// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendRecoveryEmail_container__gXHhI {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SendRecoveryEmail_resetPasswordContainer__lJRUZ {
  background: var(--background-color-1);
  box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.2);
  padding: 1.5rem;
  width: 400px;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.SendRecoveryEmail_resetPasswordContainer__lJRUZ form {
  width: 100%;
}

.SendRecoveryEmail_form__GWqUq {
  margin-top: 20px;
}

.SendRecoveryEmail_inputGroup__qPBvs {
  margin: 10px 0;
}

.SendRecoveryEmail_input__2M0eD {
  font-size: 1rem;
  border: 1px solid var(--darkgray);
  border-radius: var(--border-radius);
  min-height: 2rem;
  height: 2rem;
  width: 100%;
  background: var(--white);
  padding: 0.25rem 0.5rem;
  transition: all 0.3s;
  margin: 5px 0;
}

.SendRecoveryEmail_inputLabel__eMemx {
  display: block;
  font-size: 1.1rem;
  font-weight: var(--bold);
}

.SendRecoveryEmail_error__xXMUf {
  font-weight: 400;
  font-size: 0.75rem;
  color: var(--danger);
}

.SendRecoveryEmail_submitButton__8rgJ4 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.SendRecoveryEmail_instructions__EAnzJ {
  font-size: 1rem;
  text-align: center;
  line-height: 1.5;
}

.SendRecoveryEmail_loginLink__kGIrb {
  display: block;
  margin-top: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/views/SendRecoveryEmail/styles/SendRecoveryEmail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qCAAA;EACA,0CAAA;EAEA,eAAA;EACA,YAAA;EAGA,kBAAA;EAEA,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,8BAAA;AAJF;AAME;EACE,WAAA;AAJJ;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,eAAA;EAEA,iCAAA;EACA,mCAAA;EAEA,gBAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EAEA,uBAAA;EAEA,oBAAA;EAEA,aAAA;AAXF;;AAcA;EACE,cAAA;EACA,iBAAA;EACA,wBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,kBAAA;EAEA,oBAAA;AAZF;;AAeA;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,cAAA;EAEA,gBAAA;EAEA,kBAAA;AAhBF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.resetPasswordContainer {\n  background: var(--background-color-1);\n  box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.2);\n\n  padding: 1.5rem;\n  width: 400px;\n  // height: 350px;\n\n  border-radius: 1em;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n  justify-content: space-between;\n\n  form {\n    width: 100%;\n  }\n}\n\n.form {\n  margin-top: 20px;\n}\n\n.inputGroup {\n  margin: 10px 0;\n}\n\n.input {\n  font-size: 1rem;\n\n  border: 1px solid var(--darkgray);\n  border-radius: var(--border-radius);\n\n  min-height: 2rem;\n  height: 2rem;\n  width: 100%;\n\n  background: var(--white);\n\n  padding: 0.25rem 0.5rem;\n\n  transition: all 0.3s;\n\n  margin: 5px 0;\n}\n\n.inputLabel {\n  display: block;\n  font-size: 1.1rem;\n  font-weight: var(--bold);\n}\n\n.error {\n  font-weight: 400;\n  font-size: 0.75rem;\n\n  color: var(--danger);\n}\n\n.submitButton {\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-top: 20px;\n}\n\n.instructions {\n  font-size: 1rem;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.loginLink {\n  display: block;\n\n  margin-top: 20px;\n\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SendRecoveryEmail_container__gXHhI`,
	"resetPasswordContainer": `SendRecoveryEmail_resetPasswordContainer__lJRUZ`,
	"form": `SendRecoveryEmail_form__GWqUq`,
	"inputGroup": `SendRecoveryEmail_inputGroup__qPBvs`,
	"input": `SendRecoveryEmail_input__2M0eD`,
	"inputLabel": `SendRecoveryEmail_inputLabel__eMemx`,
	"error": `SendRecoveryEmail_error__xXMUf`,
	"submitButton": `SendRecoveryEmail_submitButton__8rgJ4`,
	"instructions": `SendRecoveryEmail_instructions__EAnzJ`,
	"loginLink": `SendRecoveryEmail_loginLink__kGIrb`
};
export default ___CSS_LOADER_EXPORT___;
